var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"href":"#","variant":"secondary pr-1"},on:{"click":function($event){$event.stopPropagation();return _vm.edit.apply(null, arguments)}}},[_c('i',{staticClass:"far fa-edit"})])
}
var staticRenderFns = []

export { render, staticRenderFns }